import * as React from "react";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import DatePicker from "./DatePicker";
const useStyles = makeStyles(({
  breakpoints,
  typography
}) => ({
  container: {
    marginBottom: typography.pxToRem(35)
  },
  title: {
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(19)
    },
    [breakpoints.up("sm")]: {
      fontSize: typography.pxToRem(21)
    },
    lineHeight: 1.49,
    letterSpacing: 0.44,
    textAlign: "center"
  },
  subTitle: {
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(14),
      maxWidth: "95%"
    },
    [breakpoints.up("sm")]: {
      fontSize: typography.pxToRem(19)
    },
    marginTop: typography.pxToRem(26.7),
    fontWeight: 300,
    lineHeight: 1.42,
    letterSpacing: 0.44,
    textAlign: "center",
    color: "#b7b9bd"
  }
}));

const SelectDay = ({
  title,
  subtitle,
  selectedDate,
  dates,
  onSelect,
  classes = {}
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    justify: "center",
    alignItems: "center",
    className: styles.container
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.title
  }, title), !!subtitle && /*#__PURE__*/React.createElement(Typography, {
    className: styles.subTitle
  }, subtitle), /*#__PURE__*/React.createElement(DatePicker, {
    selectedDate: selectedDate,
    dates: dates,
    onSelect: onSelect,
    classes: classes
  }));
};

export default SelectDay;